import type { CheckoutConfig } from './checkoutConfig.types';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Deep merge raso o suficiente para o shape do `CheckoutConfig` (2 níveis: bloco → campo).
 * Usado só para aplicar patches parciais recebidos via `postMessage` no modo preview —
 * nunca para o `PATCH` real do admin (esse substitui o `config` inteiro, por decisão do plano).
 */
export function mergePartialCheckoutConfig(
  base: CheckoutConfig,
  patch: Partial<CheckoutConfig>,
): CheckoutConfig {
  const baseRecord = base as unknown as Record<string, unknown>;
  const patchRecord = patch as unknown as Record<string, unknown>;
  const result: Record<string, unknown> = { ...baseRecord };

  for (const key of Object.keys(patchRecord)) {
    const patchValue = patchRecord[key];
    const baseValue = baseRecord[key];
    if (isPlainObject(patchValue) && isPlainObject(baseValue)) {
      result[key] = { ...baseValue, ...patchValue };
    } else if (patchValue !== undefined) {
      result[key] = patchValue;
    }
  }

  return result as unknown as CheckoutConfig;
}
